import React from 'react';
import styled from 'styled-components';
import { Body7 } from '@ui';
import { formatStatus } from './format';

// Maps a job status to the theme token used for its dot. In-flight statuses (running, canceling)
// get a pulse. canceled reads neutral, not negative — a cancel is a deliberate stop, not a failure.
const DOT_TOKENS = {
  queued: 'secondaryText',
  running: 'primaryCtaButton',
  completed: 'positive',
  failed: 'negative',
  canceled: 'secondaryText',
  canceling: 'warning',
};

const PULSING_STATUSES = ['running', 'canceling'];

const Pill = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 10px;
  border-radius: 999px;
  border: 1px solid ${({ theme }) => theme.themeColors.lowContrastBorder};
  background: ${({ theme }) => theme.themeColors.componentNoOpacity};
  white-space: nowrap;
`;

const Dot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
  background: ${({ theme, $token }) => theme.themeColors[$token] || theme.themeColors.secondaryText};

  ${({ $pulse }) =>
    $pulse &&
    `
    animation: statusBadgePulse 1.4s ease-in-out infinite;
  `}

  @keyframes statusBadgePulse {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.35;
    }
    100% {
      opacity: 1;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const StatusBadge = ({ status }) => {
  const token = DOT_TOKENS[status] || 'secondaryText';
  return (
    <Pill>
      <Dot $token={token} $pulse={PULSING_STATUSES.includes(status)} />
      <Body7 bold>{formatStatus(status)}</Body7>
    </Pill>
  );
};
